import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=bc43b6ee&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc43b6ee')) {
      api.createRecord('bc43b6ee', component.options)
    } else {
      api.reload('bc43b6ee', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=bc43b6ee&", function () {
      api.rerender('bc43b6ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uF5OhO5PjGL6/JS/offershelp.vue"
export default component.exports